import styled from 'styled-components'

export const Message = styled.div`
  padding: 0 15px;
  color: ${props =>
    props.error ? props.theme.colors.red : props.theme.colors.darkGray};
`



// WEBPACK FOOTER //
// ./src/Components/Form/ErrorMessage/style.js